export default __webpack_public_path__ + "static/media/AnexarMaisComTexto.d9cf9a00.svg";